export const Marketing = {
  TrialDuration: 7,
};
